export const INLINE_VIDEO_PLAYER = {
  PLAY: "Play",
  PAUSE: "Pause",
  STOP: "Stop",
  FULLSCREEN: "Fullscreen",
} as const;
